import React, { useEffect, useState } from 'react';
import AddConractForm from 'components/AddNewContractModal/Forms';
import Modal from 'components/Modal';
import { connect, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { SizedLongBody } from 'components/AddNewContractModal/styles';
import { translate } from 'helpers/intl';
import messages from 'components/AddNewContractModal/messages';
import { createStructuredSelector } from 'reselect';
import {
  getContractTypeSelector,
  getIsloadingProductSelector,
  getProductSelector,
} from 'store/contract/selectors';
import {
  getContractType,
  addNewContract,
  closeAddNewContractModal,
  openAddNewContractModal,
  getProduitEpargn,
} from 'store/contract/actions';
import AddNewContractSuccessModal from 'components/AddNewContractSuccessModal';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { isReverse } from 'helpers/intl';

const AddNewContractModal = ({
  openAddNewContractModal,
  handleOpenModal,
  handleCloseModal,
  contractType,
  getContractType,
  getProduitEpargn,
  closeAddNewContractModal,
  productEpargn,
  isLoadingProductEpargn,
  isOpen,
  ...props
}: any) => {
  const [isEpargn, setIsEpargn] = useState(false);
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  useEffect(() => {
    getContractType();
  }, [getContractType, lang]);

  useEffect(() => {
    isEpargn && getProduitEpargn();
  }, [getProduitEpargn, isEpargn]);
  return (
    <>
      <Modal
        open={isOpen}
        handleOpen={openAddNewContractModal}
        handleClose={closeAddNewContractModal}
        header={
          <SizedLongBody reverse={reverse} weight="500" color="#04336B">
            {translate({ ...messages.title }, props)}
          </SizedLongBody>
        }
        content={
          <>
            <AddConractForm
              setIsEpargn={setIsEpargn}
              isLoadingProducts={isLoadingProductEpargn}
              productEpargn={productEpargn}
              contractType={contractType}
              addNewContract={props.addNewContract}
              handleClose={closeAddNewContractModal}
            />
          </>
        }
      ></Modal>
      <AddNewContractSuccessModal />
    </>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    contractType: {
      type: string;
      value: string;
    }[];
    productEpargn: [];
    isLoadingProductEpargn: boolean;
  }
>({
  contractType: getContractTypeSelector,
  productEpargn: getProductSelector,
  isLoadingProductEpargn: getIsloadingProductSelector,
});

const mapDispatchToProps = {
  getContractType,
  getProduitEpargn,
  addNewContract,
  closeAddNewContractModal,
  openAddNewContractModal,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AddNewContractModal));
export { AddNewContractModal as AddNewContractModalTest };
